import React, { useState } from 'react'

export default function TermsAndConditions({ accepted, onChange, onAccept, onReject }) {
  const [expanded, setExpanded] = useState(false)

  const handleAccept = () => {
    onChange(true)
    onAccept?.()
  }

  const handleReject = () => {
    onChange(false)
    onReject?.()
  }

  return (
    <div className="space-y-4">
      <div className="rounded-lg border-2 border-amber-200 bg-amber-50 p-4">
        <button
          type="button"
          onClick={() => setExpanded(!expanded)}
          className="w-full flex items-center justify-between text-left hover:bg-amber-100 transition-colors p-2 rounded"
        >
          <div className="flex items-center gap-3">
            <svg className={`h-6 w-6 text-amber-600 flex-shrink-0 transform transition-transform ${expanded ? 'rotate-90' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
            <div>
              <h3 className="font-semibold text-amber-900">Visitor Policy: Do's & Don'ts</h3>
              <p className="text-xs text-amber-700">Click to read safety guidelines before acceptance</p>
            </div>
          </div>
        </button>

        {expanded && (
          <div className="mt-4 space-y-4 pl-8 border-t border-amber-200 pt-4">
            {/* Do's Section */}
            <div>
              <h4 className="font-semibold text-amber-900 mb-3 flex items-center gap-2">
                <svg className="h-5 w-5 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                Do's
              </h4>
              <ul className="space-y-2 text-sm text-gray-700">
                <li className="flex items-start gap-2">
                  <span className="text-green-600 font-bold mt-0.5">✓</span>
                  <span><strong>Safety First:</strong> igus (India) Private Limited prioritizes SAFETY above all. Strictly adhere to our safety guidelines and Emergency Preparedness Procedures.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-green-600 font-bold mt-0.5">✓</span>
                  <span><strong>Authorized Personnel:</strong> Visitors must be accompanied by authorized personnel for any service visit.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-green-600 font-bold mt-0.5">✓</span>
                  <span><strong>Personal Protective Equipment (PPE):</strong> Wear appropriate PPE at all times as per requirements.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-green-600 font-bold mt-0.5">✓</span>
                  <span><strong>Safety Responsibility:</strong> Ensure your own safety and that of others around you.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-green-600 font-bold mt-0.5">✓</span>
                  <span><strong>Badge Handover:</strong> Hand over your visitor pass to security while exiting.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-green-600 font-bold mt-0.5">✓</span>
                  <span><strong>Report Incidents:</strong> Report any incidents or unsafe practices immediately to Security.</span>
                </li>
              </ul>
            </div>

            {/* Don'ts Section */}
            <div>
              <h4 className="font-semibold text-amber-900 mb-3 flex items-center gap-2">
                <svg className="h-5 w-5 text-red-600" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                </svg>
                Don'ts
              </h4>
              <ul className="space-y-2 text-sm text-gray-700">
                <li className="flex items-start gap-2">
                  <span className="text-red-600 font-bold mt-0.5">✕</span>
                  <span><strong>No Smoking:</strong> Smoking is strictly prohibited in all factory areas.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-red-600 font-bold mt-0.5">✕</span>
                  <span><strong>No Harmful Activities:</strong> Do not engage in any activity that could harm our staff or other interested parties.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-red-600 font-bold mt-0.5">✕</span>
                  <span><strong>Restricted Areas:</strong> Do not enter any area without explicit permission.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-red-600 font-bold mt-0.5">✕</span>
                  <span><strong>PPE Mandatory:</strong> Do not work without appropriate Personal Protective Equipment (PPE).</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-red-600 font-bold mt-0.5">✕</span>
                  <span><strong>Work Permissions:</strong> Do not perform any work without proper work permissions and authorization.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-red-600 font-bold mt-0.5">✕</span>
                  <span><strong>Valid ID & Privacy:</strong> Carry valid ID proof. Do not take unauthorized photos/videos or share confidential information.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-red-600 font-bold mt-0.5">✕</span>
                  <span><strong>Respect Company Property:</strong> Do not damage or disrespect company property.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-red-600 font-bold mt-0.5">✕</span>
                  <span><strong>Check-in/Check-out:</strong> Failure to follow proper check-in and check-out procedures may result in security alerts.</span>
                </li>
              </ul>
            </div>
          </div>
        )}
      </div>

      {/* Checkbox and Agreement */}
      <div className="flex items-start gap-3">
        <input
          type="checkbox"
          id="termsAccept"
          checked={accepted}
          onChange={(e) => {
            if (e.target.checked) {
              handleAccept()
            } else {
              handleReject()
            }
          }}
          className="mt-1 h-4 w-4 rounded border-gray-300 text-saffron-600 shadow-sm focus:border-saffron-500 focus:ring-2 focus:ring-saffron-200 cursor-pointer"
        />
        <label htmlFor="termsAccept" className="text-sm text-gray-700 cursor-pointer">
          <span className="font-medium">I have read and accept</span> the Visitor Policy, Do's & Don'ts, and understand the safety guidelines. I agree to follow all instructions and take full responsibility for my safety and compliance.
        </label>
      </div>

      {!accepted && (
        <p className="text-xs text-red-600 flex items-center gap-2">
          <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
          </svg>
          You must accept the terms and conditions to proceed
        </p>
      )}
    </div>
  )
}
